import { IListGateway, ISaveGateway } from '../gateways';
import { API_RESPONSE_SCHEMA, IApiResponse } from '@web/shared-types';
import { BANK_DATA_ARRAY_SCHEMA, IBankData, ICreateBankData } from '@web/dtos';
import { RestCallBuilder } from '../../../builder/rest/rest-call.builder';
import { Observable } from 'rxjs';
import { AppConfigService } from '../../app-config.service';
import { inject } from '@angular/core';

export class BankDataGateway
  implements
    IListGateway<void, IApiResponse<IBankData[]>>,
    ISaveGateway<ICreateBankData, IApiResponse<IBankData[]>>
{
  private readonly configService: AppConfigService = inject(AppConfigService);
  private readonly listRestCallBuilder: RestCallBuilder<void, IBankData[]> =
    new RestCallBuilder<void, IBankData[]>([]);
  private readonly saveRestCallBuilder: RestCallBuilder<
    ICreateBankData,
    IBankData[]
  > = new RestCallBuilder<ICreateBankData, IBankData[]>([]);

  list(): Observable<IApiResponse<IBankData[]>> {
    return this.listRestCallBuilder
      .getExternal(
        `${this.configService.get().general.userServiceUrl}/bank-data`
      )
      .validate(API_RESPONSE_SCHEMA(BANK_DATA_ARRAY_SCHEMA), 'BankData.get')
      .handleMessages()
      .build();
  }

  save(query: ICreateBankData): Observable<IApiResponse<IBankData[]>> {
    return this.saveRestCallBuilder
      .postExternal(
        `${this.configService.get().general.userServiceUrl}/bank-data/`,
        query
      )
      .validate(API_RESPONSE_SCHEMA(BANK_DATA_ARRAY_SCHEMA), 'BankData.save')
      .handleMessages()
      .build();
  }
}
